import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Card, Table, Form, Toast } from 'react-bootstrap';

const FeaturesManagement = ({ onSave, data, customRoles }) => {
    const userType = data?.value;

    const initialStructure = useMemo(() => (userType === '3' ?
        [
            { type: 'header', name: 'Dashboard' },
            { type: 'feature', name: 'Dashboard', read: true, download: true },

            { type: 'header', name: 'Reports' },
            { type: 'feature', name: 'Campaign Analytics', read: true, download: true },
            { type: 'feature', name: 'FailOver Analytics', read: true, download: true },
            { type: 'feature', name: 'SMS Reports', read: true, download: true },
            { type: 'feature', name: 'WhatsApp Reports', read: true, download: true },
            { type: 'feature', name: 'RCS Reports', read: true, download: true },

            { type: 'header', name: 'Templates' },
            { type: 'feature', name: 'Templates', read: true, download: true },
            { type: 'header', name: 'Campaign' },
            { type: 'feature', name: 'Campaign', read: true, download: true },
        ] : userType === '4' ?
            [
                { type: 'header', name: 'Dashboard' },
                { type: 'feature', name: 'Dashboard', read: true, download: true },
                { type: 'header', name: 'Reports' },
                { type: 'feature', name: 'Campaign Analytics', read: true, download: true },
                { type: 'feature', name: 'FailOver Analytics', read: true, download: true },
                { type: 'feature', name: 'SMS Reports', read: true, download: true },
                { type: 'feature', name: 'WhatsApp Reports', read: true, download: true },
                { type: 'feature', name: 'RCS Reports', read: true, download: true },

                { type: 'header', name: 'User Management' },
                { type: 'feature', name: 'User Management', read: true, edit: false, download: true, delete: false },
                { type: 'header', name: 'Connectivity Setup' },
                { type: 'feature', name: 'SMS SMPP Account', read: true, edit: false, download: true, delete: false },
                customRoles && { type: 'header', name: 'SenderID' },
                customRoles && { type: 'feature', name: 'SenderID Registration', read: true, edit: true, download: true },
                { type: 'header', name: 'Mapping' },
                { type: 'feature', name: 'Routes Mapping', read: true, edit: false, download: true, delete: false },
                { type: 'feature', name: 'Reporting User', read: true, edit: false, download: true, delete: false },
                { type: 'header', name: 'Wallet' },
                { type: 'feature', name: 'Enterprise Wallet', read: true, edit: false, download: true },
                { type: 'header', name: 'Templates' },
                { type: 'feature', name: 'Templates', read: true, edit: true, download: false, delete: true },
                { type: 'header', name: 'Campaign' },
                { type: 'feature', name: 'Campaign', read: true, download: true },
                { type: 'header', name: 'Contact List' },
                { type: 'feature', name: 'Contact List', read: true, download: true },
                { type: 'header', name: 'ChatBot' },
                { type: 'feature', name: 'ChatBot', read: true, edit: true, download: false, delete: false },
                { type: 'header', name: 'WA Profiles' },
                { type: 'feature', name: 'WA Profiles', read: true, edit: false},
            ] : userType === '7' ?
                [
                    { type: 'header', name: 'Dashboard' },
                    { type: 'feature', name: 'Dashboard', read: true, download: true },
                    { type: 'header', name: 'Reports' },
                    { type: 'feature', name: 'Campaign Analytics', read: true, download: true },
                    { type: 'feature', name: 'FailOver Analytics', read: true, download: true },
                    { type: 'feature', name: 'SMS Reports', read: true, download: true },
                    { type: 'feature', name: 'WhatsApp Reports', read: true, download: true },
                    { type: 'feature', name: 'RCS Reports', read: true, download: true },
                    { type: 'header', name: 'Connectivity Setup' },
                    { type: 'feature', name: 'SMS SMPP Account', read: true, download: true },
                    { type: 'header', name: 'Mapping' },
                    { type: 'feature', name: 'Routes Mapping', read: true, download: true },
                    { type: 'header', name: 'Templates' },
                    { type: 'feature', name: 'Templates', read: true, download: true },
                    { type: 'header', name: 'Campaign' },
                    { type: 'feature', name: 'Campaign', read: true, edit: true, download: true, delete: true },
                    { type: 'header', name: 'Contact List' },
                    { type: 'feature', name: 'Contact List', read: true, edit: true, download: true, delete: true },
                ] : userType === '8' ?
                    [
                        { type: 'header', name: 'Dashboard' },
                        { type: 'feature', name: 'Dashboard', read: true, download: true },
                        { type: 'header', name: 'Reports' },
                        { type: 'feature', name: 'Campaign Analytics', read: true, download: true },
                        { type: 'feature', name: 'FailOver Analytics', read: true, download: true },
                        { type: 'feature', name: 'SMS Reports', read: true, download: true },
                        { type: 'feature', name: 'WhatsApp Reports', read: true, download: true },
                        { type: 'feature', name: 'RCS Reports', read: true, download: true },
                        { type: 'header', name: 'Mapping' },
                        { type: 'feature', name: 'Reporting User', read: true, download: true},
                        { type: 'header', name: 'Templates' },
                        { type: 'feature', name: 'Templates', read: true, download: true },
                        { type: 'header', name: 'Campaign' },
                        { type: 'feature', name: 'Campaign', read: true, download: true },
                    ] :
                    [
                        { type: 'header', name: 'Dashboard' },
                        { type: 'feature', name: 'Dashboard', read: true, download: true },
                        { type: 'header', name: 'Reports' },
                        { type: 'feature', name: 'Campaign Analytics', read: true, download: true },
                        { type: 'feature', name: 'FailOver Analytics', read: true, download: true },
                        { type: 'feature', name: 'SMS Reports', read: true, download: true },
                        { type: 'feature', name: 'WhatsApp Reports', read: true, download: true },
                        { type: 'feature', name: 'RCS Reports', read: true, download: true },
                        { type: 'header', name: 'User Management' },
                        { type: 'feature', name: 'User Management', read: true, edit: false, download: true, delete: false },
                        { type: 'header', name: 'Connectivity Setup' },
                        { type: 'feature', name: 'SMS SMPP Account', read: true, edit: false, download: true, delete: false },
                        { type: 'feature', name: 'SMSC Registration', read: true, edit: false, download: true, delete: false },
                        { type: 'feature', name: 'SMSC Rates', read: true, download: true },
                        { type: 'feature', name: 'WA BSPs', read: true, download: true },
                        { type: 'feature', name: 'WA Rates', read: true, download: true },
                        { type: 'feature', name: 'RCS BSPs', read: true, download: true },
                        { type: 'feature', name: 'RCS Rates', read: true, download: true },
                        customRoles && { type: 'header', name: 'SenderID' },
                        customRoles && { type: 'feature', name: 'SenderID Registration', read: true, edit: true, download: true},
                        { type: 'header', name: 'Mapping' },
                        { type: 'feature', name: 'Routes Mapping', read: true, edit: false, download: true, delete: false },
                        { type: 'feature', name: 'Reporting User', read: true, edit: false, download: true, delete: false },
                        { type: 'header', name: 'Vendor Management' },
                        { type: 'feature', name: 'Vendor Management', read: true, edit: false, download: true, delete: false },
                        { type: 'header', name: 'Routing' },
                        { type: 'feature', name: 'Routing', read: true, edit: false, download: true, delete: false },
                        { type: 'header', name: 'Wallet' },
                        { type: 'feature', name: 'Enterprise Wallet', read: true, edit: false, download: true },
                        { type: 'feature', name: 'Vendor Wallet', read: true, edit: false, download: true },
                        { type: 'header', name: 'Templates' },
                        { type: 'feature', name: 'Templates', read: true, download: true },
                        { type: 'header', name: 'Campaign' },
                        { type: 'feature', name: 'Campaign', read: true, download: true },
                        { type: 'header', name: 'Channel Testing' },
                        { type: 'feature', name: 'Channel Testing', read: true, edit: true },
                        { type: 'header', name: 'System Monitor' },
                        { type: 'feature', name: 'ESME List', read: true },
                        { type: 'feature', name: 'SMSC List', read: true },
                    ]
                ).filter(Boolean), [userType, customRoles]);

    const [permissions, setPermissions] = useState([]);
    const [showToast, setShowToast] = useState(false);

    const onSaveRef = useRef(onSave);
    useEffect(() => {
        onSaveRef.current = onSave;
    }, [onSave]);

    useEffect(() => {
        setPermissions(initialStructure);
    }, [initialStructure]);

    useEffect(() => {
        const featuresOnly = permissions
            .filter(p => p.type === 'feature')
            .map(f => ({
                name: f.name,
                read: f.read,
                edit: f.edit,
                download: f.download,
                delete: f.delete
            }));
        onSaveRef.current(featuresOnly);
    }, [permissions]);

    const handlePermissionChange = (index, permissionType) => {
        setPermissions(prev => {
            const newPermissions = [...prev];
            const current = newPermissions[index][permissionType];

            newPermissions[index] = {
                ...newPermissions[index],
                [permissionType]: !current
            };

            return newPermissions;
        });
        setShowToast(true);
    };


    return (
        <Card className="border-1">
            <Card.Body className="p-0">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="mb-0">Features Management</h5>
                   
                </div>

                <Table borderless hover className="m-0">
                    <thead className="bg-gray-300">
                        <tr>
                            <th style={{ width: '40%' }}>Feature</th>
                            <th className="text-center">Read</th>
                            <th className="text-center">Create/Edit</th>
                            <th className="text-center">Download</th>
                            <th className="text-center">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {permissions.map((perm, index) => (
                            <tr
                                key={index}
                                className={perm.type === 'header' ? 'bg-gray-50' : ''}
                            >
                                <td style={{
                                    paddingLeft: perm.type === 'feature' ? '2.5rem' : '1rem',
                                    fontWeight: perm.type === 'header' ? '600' : '400'
                                }}>
                                    {perm.name}
                                </td>
                                {['read', 'edit', 'download', 'delete'].map((field) => (
                                    <td key={field} className="text-center">
                                        {perm[field] === undefined ? null : (
                                            <Form.Check
                                                type="checkbox"
                                                name={`perm-${perm.name}`}  // Changed to use feature name instead of index
                                                checked={perm[field]}
                                                onChange={() => handlePermissionChange(index, field)}
                                                className="d-inline-block"
                                            />
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <Toast
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    delay={3000}
                    autohide
                    className="position-fixed bottom-0 end-0 m-3"
                    bg="success"
                >
                    <Toast.Body className="text-white">Permissions updated successfully!</Toast.Body>
                </Toast>
            </Card.Body>
        </Card>
    );
};

export default FeaturesManagement;